'use client';

import { Header } from '@/components';
import Footer from '@/components/footer/Footer';
import { useThemeMode } from '@/context';
import {
  FlexItem,
  FlexLayout,
  Typography,
  Image,
  Container,
  Button,
  useTheme,
  responsive,
  Icon,
} from '@wci-tech/core-ui';

import { BsArrowUpRight } from 'react-icons/bs';
import { css } from '@emotion/react';
import { getContainerStyles } from '@/utils';
import { useTranslations } from 'next-intl';

const NotFound = () => {
  const { theme } = useTheme();
  const { isDark } = useThemeMode();

  const t = useTranslations('NotFound');

  const containerStyles = css`
    ${getContainerStyles(theme)};
    ${responsive.create({
      paddingTop: {
        default: theme.spacing.get(56),
        md: theme.spacing.get(44),
        lg: theme.spacing.get(116),
      },
      paddingBottom: {
        default: theme.spacing.get(52),
        md: theme.spacing.get(44),
        lg: theme.spacing.get(116),
      },
    })}
  `;

  const notFoundTextStyles = css`
    color: ${isDark ? theme.colors.commonColors.white : '#212121'};
    font-weight: ${theme.fonts.weight.medium};
    ${responsive.create({
      fontSize: {
        default: theme.fonts.size.xxl,
        md: theme.fonts.size['5xl'],
        lg: theme.fonts.size['6xl'],
      },
    })};
  `;

  return (
    <>
      <Header showNavbar={false} disableScrollEffect />
      <main>
        <Container customStyles={containerStyles}>
          <FlexLayout
            alignItems={'center'}
            justifyContent={'center'}
            direction={'column'}
            padding={{ default: 0 }}
            gap={{ default: 16, md: 24 }}
          >
            <FlexItem>
              <Image
                isImgDecorative={true}
                altText={t('imageAlt')}
                // Default mobile source
                src="/images/PageNotFoundMobile.png"
                priority={true}
                fetchPriority="high"
                preload={true}
                loading="eager"
                objectFit="contain"
                width={{
                  default: 288,
                  md: 506,
                  lg: 596,
                }}
                height={{
                  default: 248,
                  md: 368,
                  lg: 432,
                }}
                sizes="(max-width: 767px) 288px, (max-width: 1023px) 506px, 596px"
                sources={[
                  {
                    srcSet: '/images/PageNotFoundDesktop.png',
                    media: '(min-width: 1024px)',
                    type: 'image/png',
                  },
                  {
                    srcSet: '/images/PageNotFoundTablet.png',
                    media: '(min-width: 768px)',
                    type: 'image/png',
                  },
                ]}
              />
            </FlexItem>
            <FlexItem>
              <Typography variant="h1" customStyles={notFoundTextStyles}>
                {t('title')}
              </Typography>
            </FlexItem>
            <FlexItem>
              <Button
                appearance="outline"
                variant={isDark ? 'secondary' : 'primary'}
                effect="liquid-fill"
                icon={
                  <Icon
                    name={BsArrowUpRight}
                    size={{
                      default: '14px',
                      lg: '16px',
                    }}
                  />
                }
                iconPlacement="right"
                shape="pill"
                href="/"
                customStyles={{
                  icon: {
                    right: css`
                      svg {
                        stroke-width: 0.6;
                      }
                    `,
                  },
                }}
              >
                {t('button')}
              </Button>
            </FlexItem>
          </FlexLayout>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
